import { create } from 'zustand';

/**
 * App-eigene Textgrößen-Einstellung (Normal/Groß/Sehr groß) — Ersatz dafür, dass
 * iOS Safari die System-Textgröße (Dynamic Type) an Webinhalte nicht weitergibt
 * (keine CSS-Media-Query/JS-API dafür). Skaliert die Root-Schriftgröße
 * (`:root[data-text-size]` in globals.css); alle rem-basierten Tailwind-Klassen
 * (text-xs/sm/base/lg …) folgen automatisch mit.
 */
export type TextSize = 'normal' | 'gross' | 'sehr-gross';

export const TEXT_SIZE_LABELS: Record<TextSize, string> = {
  normal: 'Normal',
  gross: 'Groß',
  'sehr-gross': 'Sehr groß',
};

const STORAGE_KEY = 'proerp-text-size';

function readStored(): TextSize | null {
  const value = typeof localStorage !== 'undefined' ? localStorage.getItem(STORAGE_KEY) : null;
  return value === 'normal' || value === 'gross' || value === 'sehr-gross' ? value : null;
}

function apply(size: TextSize): void {
  if (size === 'normal') {
    document.documentElement.removeAttribute('data-text-size');
  } else {
    document.documentElement.setAttribute('data-text-size', size);
  }
}

const initial: TextSize = readStored() ?? 'normal';

interface TextSizeState {
  textSize: TextSize;
  setTextSize: (size: TextSize) => void;
}

export const useTextSize = create<TextSizeState>((set) => ({
  textSize: initial,
  setTextSize: (size) => {
    localStorage.setItem(STORAGE_KEY, size);
    apply(size);
    set({ textSize: size });
  },
}));

/** Vor dem ersten Render aufrufen (main.tsx) — vermeidet ein Aufblitzen der Normalgröße. */
export function initTextSize(): void {
  apply(initial);
}
